import React from "react";
import { inject } from "mobx-react";
import { getGanttLayout, getGanttZoomConfig } from "./GanttConfig";
import Gantt from "../../../../../lib/Gantt/Dhtmlx/components/Gantt";
import { renderStopPopup, renderAdditionalElementOnGanttTimeline } from "./GanttHelper";
import { getShowProDetailsData, getTotalDwellTime, getTotalStopTime } from "../util";
import { isValidPickupNumber } from "../../../utils";
import { getDriverStopDetails } from "../../../../../components/modules/Dispatch/RouteExecution/ProDetails/PickupProInfo/utils";
import { utcToZonedTime } from "date-fns-tz";
import constants from "./constants";
import { withAppConfig } from "../../../../../appConfigContext";
import withRouter from "../../../../../routes/withRouter";
import { withTheme } from "@material-ui/core";
import { compose } from "recompose";
import { withSnackbar } from "notistack";

class DispatchGantt extends React.Component {
  constructor(props) {
    super(props);
  }

  onGanttReady = (gantt) => {
    this.gantt = gantt;
  };

  onBeforeDataRender = () => {
    if (this.props.isRealtimeReport) {
      const { gantt } = this;
      if (gantt) {
        const currentTasks = gantt
        ?.getTaskByTime()
        ?.filter((task) => task.isCurrentStop);        
        gantt.batchUpdate(() => this.updateAllCurrentTasks(currentTasks));
      }
    }
  };

  getCurrentTime = () => {
    return utcToZonedTime(new Date(), this.props.terminalOffset);
  };

  updateAllCurrentTasks = (currentTasksList) => {
    currentTasksList.forEach((task) => {
      const currentDateTime = this.getCurrentTime();
      const currentDateTimeStr =
        gantt.date.date_to_str(constants.GANTT_DATE_TIME_FORMAT)(currentDateTime);
      const actualArrivalTime = task.data.actualArrivalTime;
      if (currentDateTime > task.end_date) {
        const currentStopDuration = getTotalStopTime(
          actualArrivalTime,
          currentDateTimeStr
        );
        task.progress = getTotalDwellTime(
          task.stopDuration,
          currentStopDuration
        );
        task.end_date = currentDateTime;
        task.currentDateTime = currentDateTimeStr;
        task.departureTime = gantt.date.date_to_str(constants.GANTT_TIME_FORMAT)(currentDateTime);
        this.gantt.updateTask(task.id);
      }
    });
  };

  showProDetails = ( proId, stopId ) => {
    const { driverData, routeData } = this.getDriverAndRouteInfo(stopId);
    const { isRealtimeReport } = this.props;
    const data = getShowProDetailsData({ proId, driverData, routeData, isRealtimeReport });
    this.props.router.navigate(`?proId=${proId}`, {
      state: { data }
    });
  }

  getDriverAndRouteInfo = (stopId) => {
    const taskData = this.props?.tasks?.tasks?.find?.((task) => task.id === stopId);
    const { driverData, routeData } = taskData ?? {};
    return { driverData, routeData };
  }
  

  showPickupDetails = (pickupNumber, stopId) => {
    const { driverData, routeData } = this.getDriverAndRouteInfo(stopId); 
    if(isValidPickupNumber(pickupNumber)) {
      const historicDriverDetails= {routeData: {...routeData, driverId: driverData.driverId}, stopId};
      this.props.router.navigate(`?pickupNumber=${pickupNumber}`, {
        state: {
          pickupInfo: null,
          shipmentAPI: 'GetPastPickupShipments',
          driverDetails: getDriverStopDetails({historicDriverDetails}),
          isPickupHistory: false,
          isPastPickup: true,
          closeOnRefresh: true,
          shouldGetShipmentsFromAPI: true,
          terminalCode:driverData.terminalCode,
          proImageApiName: this.props.isRealtimeReport ? 'GetImages' : 'StopImages'
        }
      });
    } else {
      this.props.enqueueSnackbar('Pickup details not found', {
        variant: 'error'
      });
    }
  };

  isTaskFiltered = (task, filterData) => {
    const fieldsToCheck = ['text', 'driverNumber'];
    return fieldsToCheck.some(
      (field) => task[field]?.toLowerCase().includes(filterData.toLowerCase())
    );
  };

  render() {
    const { DispatchStore } = this.props;
    const enableReturnExceptionReasonLabels = Boolean(
      this.props.configJSON?.enableReturnExceptionReasonLabels
    );
    return (
      <Gantt
        ganttLayout={getGanttLayout(
          this.props.configJSON.showTrailerScac,
          this.props.theme,
          DispatchStore,
          enableReturnExceptionReasonLabels
        )}
        renderStopPopup={(task) =>
          renderStopPopup(task, DispatchStore, enableReturnExceptionReasonLabels)
        }
        zoomLevels={getGanttZoomConfig()}
        onGanttReady={this.onGanttReady}
        onBeforeDataRender={this.onBeforeDataRender}
        showProDetails={this.showProDetails}
        showPickupDetails={this.showPickupDetails}
        isTaskFiltered={this.isTaskFiltered}
        renderAdditionalElementOnGanttTimeline={(task) =>
          renderAdditionalElementOnGanttTimeline(task, this.props.theme)
        }
        {...this.props}
      />
    );
  }
}

export default compose(
  inject("DispatchStore"),
  withRouter,
  withAppConfig,
  withTheme(),
  withSnackbar
)(DispatchGantt);
